/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pregnancy_Training_TermsInputs */

const en_service_type_pregnancy_training_terms = /** @type {(inputs: Service_Type_Pregnancy_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pregnancy, prenatal, postnatal, postpartum, new mum, diastasis recti`)
};

const pl_service_type_pregnancy_training_terms = /** @type {(inputs: Service_Type_Pregnancy_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ciąża, kobiety w ciąży, po porodzie, połóg, mama, rozejście mięśni brzucha, rozstęp`)
};

/**
* | output |
* | --- |
* | "pregnancy, prenatal, postnatal, postpartum, new mum, diastasis recti" |
*
* @param {Service_Type_Pregnancy_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pregnancy_training_terms = /** @type {((inputs?: Service_Type_Pregnancy_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pregnancy_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pregnancy_training_terms(inputs)
	return en_service_type_pregnancy_training_terms(inputs)
});